// When we add a route to react, we also have to add it here. Angular won't render anything, but it's the only
// way that angular knows not to treat it as a missing page.
export const REACT_ROUTER_DIRECTIVE_NAME = 'let-react-handle-it';
